const faqs = [
  {
    q: 'UU漫画真的完全免费吗？',
    a: '是的，UU漫画平台所有<strong>免费漫画全集</strong>资源均完全免费，无需注册、无需付费、无需会员，打开即看。我们致力于为漫迷提供无障碍的<strong>在线免费阅读</strong>体验。',
  },
  {
    q: '漫画资源多久更新一次？',
    a: '我们每日同步更新，确保<strong>免费完整版漫画</strong>的最新话第一时间上线。热门连载通常在日本连载更新后24小时内即可在UU漫画阅读。',
  },
  {
    q: '需要下载APP才能看漫画吗？',
    a: '不需要。UU漫画支持手机、平板、电脑浏览器直接访问，无需下载任何APP。自适应屏幕尺寸，随时随地打开浏览器即可畅享<strong>免费漫画资源</strong>。',
  },
  {
    q: '漫画画质如何？有高清版吗？',
    a: 'UU漫画提供高清原画质阅读体验，所有漫画均保留原始分辨率和色彩细节。同时支持夜间模式，长时间阅读也不伤眼，是<strong>免费漫画大全</strong>中画质最优秀的平台之一。',
  },
  {
    q: '有没有完结的漫画全集可以一次看完？',
    a: '当然有！UU漫画收录了大量经典完结作品，支持<strong>全集免费看</strong>，从第一话到最终话一次性畅读。你可以在分类索引中按“已完结”筛选，找到心仪的完结作品。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20">
      <div className="w-full max-w-[860px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-500">关于<strong>免费漫画资源</strong>的常见疑问，这里都有答案</p>
        </div>
        <div className="flex flex-col gap-3">
          {faqs.map((faq) => (
            <div key={faq.q} className="bg-background-50 border border-background-200/60 rounded-xl p-5 md:p-6">
              <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-2">{faq.q}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: faq.a }}></p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}